import data from "./data";

const useStandaloneLandingPage = () => {
  return {
    slides: data
  };
};

export default useStandaloneLandingPage;
